var map = {
	"./all.png": 155,
	"./ayurbedic.jpg": 156,
	"./baby-care.jpg": 157,
	"./beauty-hygeine.jpg": 158,
	"./beauty-hygine.jpg": 159,
	"./beverages.png": 160,
	"./bhujia-mixture.jpg": 161,
	"./birthday.jpg": 162,
	"./biscuts.jpg": 163,
	"./cake-pastry.png": 164,
	"./chips.jpg": 165,
	"./chocolate.jpg": 166,
	"./chocolates-candy.png": 167,
	"./cookies-bread.jpg": 168,
	"./cooking-oil.jpg": 169,
	"./dairy.jpg": 170,
	"./dental-care.jpg": 171,
	"./dry-fruit.jpg": 172,
	"./face-care.png": 173,
	"./flour.jpg": 174,
	"./food-grains.jpg": 175,
	"./fragrances-deos.jpeg": 176,
	"./fruits.jpg": 177,
	"./handwash-and-sanitizer.jpg": 178,
	"./hare-care.jpeg": 179,
	"./health-essensial.jpg": 180,
	"./household-cleaning.jpeg": 181,
	"./household-cleaning.jpg": 182,
	"./juice.jpg": 183,
	"./masala.jpg": 184,
	"./masala.png": 185,
	"./packege-food.png": 186,
	"./pulse.jpg": 187,
	"./rice.jpg": 188,
	"./salt-sugar.png": 189,
	"./small/all.jpg": 49,
	"./small/bakery.jpg": 50,
	"./small/dairy.jpg": 51,
	"./small/dry-fruit.jpg": 52,
	"./small/fruits.jpg": 53,
	"./small/kirana.png": 54,
	"./small/vegitable.png": 55,
	"./soap-and-shampoo.jpg": 190,
	"./soft-drinks.jpg": 191,
	"./tea-coffee.jpg": 192,
	"./vegitable.png": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;